import type { BaseProperty } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

export const formatFilterLabel = <T extends BaseProperty>(property: T) => {
    return property.value?.map(formatWithUnit(property.unit)).join(", ");
};

const formatWithUnit = (unit: Nullable<string>) => {
    return (value: string) => (unit ? `${value} ${unit}` : value);
};
